import { useAppSelector } from 'app/hooks';
import useHybridLeftoverSpaceIds from 'hooks/use-hybrid-leftover-space-ids';
import { shallowEqual } from 'react-redux';
import { selectExpectedFullFetchConfigIds } from 'utils/pathway-configurations';

export default function useExpectedFullFetchConfigIds(): string[] {
  const leftoverSpaceIds = useHybridLeftoverSpaceIds();
  return useAppSelector(
    (state) => selectExpectedFullFetchConfigIds(state, leftoverSpaceIds),
    shallowEqual
  );
}
